import { create } from "zustand";

import type { AddNewDataFormValues } from "@/modules/add-new-data/lib/schema";

type QuestionnaireParitySession = {
  family: AddNewDataFormValues["household"]["family"];
  setFamily: (family: AddNewDataFormValues["household"]["family"]) => void;
};

export const useQuestionnaireParitySession = create<QuestionnaireParitySession>((set) => ({
  family: "A",
  setFamily: (family) => set({ family: family || "A" }),
}));
